import Axios from "axios";
import { SET_HOLIDAY_LIST, UNSET_HOLIDAY_LIST } from "@/store/mutation-types";
import { saveUpdateHoliday, getHolidayList } from "@/store/api";

// initial state
const state = {
    getHolidayList: [],
};

const getters = {
    getHolidayList(state) {
        return state.getHolidayList;
    },
};

const mutations = {
    [SET_HOLIDAY_LIST](state, data) {
        state.getHolidayList = data;
    },
    [UNSET_HOLIDAY_LIST](state) {
        state.getHolidayList = [];
    },
};  



const actions = {
    saveUpdateHoliday({ commit }, data) {   
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateHoliday, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getHolidayList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getHolidayList, data)
                .then(function (response) {
                    commit("SET_HOLIDAY_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_HOLIDAY_LIST");
                    reject(error);
                })
                .then(() => { });
        });
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
};